export default __webpack_public_path__ + "static/media/services_man_with_packages.5efcb91e.png";